module.exports = __webpack_public_path__ + "media/images/illustrations/illustration-7-1d0f21165831cb08bcd3873aec9d80c6.png";